import { createContext, useContext } from 'react';
import { highlightText as _highlightText } from './highlight';
export { _highlightText as highlightText };
export var HighlightedContext = /*#__PURE__*/createContext('');
export function useHighlightedText() {
  var highlights = useContext(HighlightedContext);
  return {
    highlights: highlights,
    highlightText: function highlightText(str) {
      return _highlightText(str, highlights);
    }
  };
}